<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center" style="height: 100vh;" wrap>
        <v-col xs="11" sm="11" md="6" lg="6" xl="6">
          <p class="text-center text-h2 font-weight-bold primary--text">
            Sorry! The page you're looking for does not exists...
          </p>
          <p class="text-center text-h1">😢</p>
        </v-col>
        <v-col cols="12" class="text-center">
          <a class="text-center text-subtitle-1" @click="$router.go(-1)"
            >Go Back</a
          >
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style></style>
